import styles from "./Tooltip.module.css";
import {
  HoverPopover,
  HoverPopoverProps,
} from "src/components/ui-components/HoverPopover/HoverPopover";

interface TooltipInteractiveProps extends HoverPopoverProps {
  "aria-label"?: string;
}
/**
 * Used for tooltips that contain interactive elements like links or
 * buttons.
 *
 * With the regular tooltip it's not possible to click inside the
 * tooltip, as it closes when you move the mouse away from the trigger.
 */
export function TooltipInteractive(props: TooltipInteractiveProps) {
  const { "aria-label": ariaLabel, content, ...otherProps } = props;

  return (
    <HoverPopover
      {...otherProps}
      content={(contentProps) => (
        <div className={styles.tooltip} aria-label={ariaLabel}>
          {content(contentProps)}
        </div>
      )}
    />
  );
}
